import ClearIcon from '@mui/icons-material/Clear';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';

interface ComponentProps {
  onClick: () => void;
}

function InputUnsetButton({ onClick }: ComponentProps) {
  return (
    <Box display="inline-block">
      <IconButton
        onClick={onClick}
        size="small"
      >
        <ClearIcon style={{ fontSize: '16px' }} />
        <Box mt="-1px"><Typography variant="body2">unset</Typography></Box>
      </IconButton>
    </Box>
  );
}
export default InputUnsetButton;
